import { useState } from "react";
import { Helmet } from "react-helmet-async";

import {
  Button,
  Grid,
  Typography,
  Divider,
  ItemTotal,
} from "@monolith-forensics/monolith-ui";
import { BuildingIcon } from "lucide-react";

import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getOffices } from "@/api";
import { usePermissions } from "@/hooks/usePermissions";

import AccessDeniedMessage from "@/components/AccessDeniedMessage.js";
import Loader from "@/components/Loader";
import { CreateOfficeModal, OfficesList } from "@/Features/Offices";

const OfficesSection = () => {
  const { hasPermission, MONOLITH_PERMISSIONS } = usePermissions();
  const [showCreateModal, setShowCreateModal] = useState(false);
  const queryClient = useQueryClient();

  const { data: offices, isFetched } = useQuery({
    queryKey: ["offices", "list"],
    queryFn: () => getOffices(),
    enabled: hasPermission(MONOLITH_PERMISSIONS.OFFICES_READ_ALL),
  });

  if (!hasPermission(MONOLITH_PERMISSIONS.OFFICES_READ_ALL))
    return <AccessDeniedMessage />;

  return (
    <>
      <Helmet title="Offices" />
      <Grid col={1}>
        <Typography variant="h3">Offices</Typography>
      </Grid>
      <Divider />
      {!isFetched && <Loader />}
      {isFetched && (
        <>
          <div style={{ marginBottom: 20, display: "flex" }}>
            <Button
              variant="contained"
              color="primary"
              size="xs"
              disabled={!hasPermission(MONOLITH_PERMISSIONS.OFFICES_CREATE)}
              onClick={() => setShowCreateModal(true)}
            >
              + New Office
            </Button>
            <CreateOfficeModal
              show={showCreateModal}
              onClose={() => setShowCreateModal(false)}
              onSubmit={() => {
                queryClient.refetchQueries({ queryKey: ["offices", "list"] });
              }}
            />
            <ItemTotal
              total={offices.length || 0}
              Icon={BuildingIcon}
              className=""
              title="Number of Office(s)"
            />
          </div>
          <OfficesList offices={offices} className="" />
        </>
      )}
    </>
  );
};

export default OfficesSection;
